import { useAppDispatch } from 'app/store';
import { categoryActions } from 'entities/faq/model/category';
import FaqCategoryTable from 'features/tables/faqCategoryTable';
import { useEffect, useMemo, useState } from 'react';
import { SimpleIcon, SimpleIconName } from 'shared/components/icons/icons';
import { useGetFaqCategoryQuery, useLazyGetFaqCategoryQuery } from 'app/services/edpApiV1/faq';
import { dataForFaqCategoryTable } from 'shared/helpers/utils';
import { Spin } from 'antd';
import { TFaqCategoryColumns, TGetFaqByIdResponse } from 'shared/types/faq.types';
import { DEFAILT_CATEGORY } from 'shared/constants/faq';
import UpdateCategoryDrawer from '../updateCategory/UpdateCategoryDrawer';

const FaqCategories = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [currentFaq, setCurrentFaq] = useState<TGetFaqByIdResponse>();
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const [getFaqCategories, { data, isLoading, isFetching }] = useLazyGetFaqCategoryQuery();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(categoryActions.setIsCategoryTab(true));
  }, []);

  useEffect(() => {
    getFaqCategories({
      size: currentSize,
      page: currentPage,
    });
  }, [currentPage, currentSize, getFaqCategories]);

  const isLast = useMemo(() => {
    return Number(data?.pagination.total) / currentPage <= currentSize;
  }, [data, currentPage, currentSize]);

  const onClickToRow = (id: number) => {
    const curCat = data?.data.find(category => category.id === id);
    setCurrentFaq(curCat ? curCat : DEFAILT_CATEGORY);
    setDrawerOpen(true);
  };

  const onDrawerClose = () => {
    setCurrentFaq(undefined);
    setDrawerOpen(false);
  };

  const columns: TFaqCategoryColumns = [
    {
      title: 'Иконка',
      dataIndex: 'icon',
      key: 'icon',
      width: '150px',
      render: (text, record) => {
        return <SimpleIcon name={record.icon as SimpleIconName} />;
      },
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title',
    },
  ];
  return (
    <Spin spinning={isLoading || isFetching}>
      <FaqCategoryTable
        dataSource={dataForFaqCategoryTable(data?.data || [], isLast)}
        columns={columns}
        currentPage={currentPage}
        currentSize={currentSize}
        setCurrentPage={setCurrentPage}
        setCurrentSize={setCurrentSize}
        total={data?.pagination.total}
        onclickToRow={onClickToRow}
      />
      <UpdateCategoryDrawer
        onClose={onDrawerClose}
        open={drawerOpen}
        title={currentFaq?.name}
        icon={currentFaq?.icon}
        id={currentFaq?.id}
      />
    </Spin>
  );
};

export default FaqCategories;
